import React from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Container, Box } from '@mui/material';

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <>
            <AppBar position="static" color="transparent" elevation={0} sx={{
                borderBottom: '1px solid #e0e0e0',
            }}>
                <Toolbar>
                    <Typography variant="h6" component={Link} to="/" sx={{
                        flexGrow: 1,
                        textDecoration: 'none',
                        color: 'inherit'
                    }}>
                        Bananaverse
                    </Typography>
                    <Button color="inherit" component={Link} to="/submit">
                        Submit Request
                    </Button>
                    <Button color="inherit" component={Link} to="/top-requests">
                        Top Requests
                    </Button>
                    <Button color="inherit" component={Link} to="/profile">
                        Profile
                    </Button>
                    <Button color="inherit">
                        Sign In
                    </Button>
                </Toolbar>
            </AppBar>
            <Container>
                <Box sx={{ my: 4 }}>
                    {children}
                </Box>
            </Container>
        </>
    );
};